<template>
    <nav aria-label="Page navigation" v-if="dataLength != 0">
        <ul class="pagination">
            <li class="page-item" ><a class="page-link"  @click="Switch(activePage-1)" :class="{disabled:(activePage-1) < 1}"><</a></li>
            <li class="page-item" 
                :class="{ active: index == activePage }" v-for="index in totalPage" :key="index.id" @click="Switch(index)" 
                v-if="index >= startPage && index <= endPage"
            ><a class="page-link" >{{index}}</a></li>
            <li class="page-item" ><a class="page-link"  @click="Switch(activePage+1)" :class="{disabled:(activePage+1) > totalPage}">></a></li>
        </ul>
    </nav>
</template>

<script>
export default {
    name: 'Pagination', 
    props: {
        dataLength: Number,
        rowPageCount:{
            type: Number,
            default: 10
        }
    },
    data () {
        return {
            activePage:1,
            totalPage:0,
            maxPageItem:3,    
            startPage:1,
            endPage:3
        }
    },
    mounted() {
        this.activePage = 1;
        this.totalPage  = Math.ceil(this.dataLength / this.rowPageCount) ;
        this.Switch(1);
    },
    watch:{
        'dataLength':function(){
            this.activePage = 1;
            this.totalPage  = Math.ceil(this.dataLength / this.rowPageCount) ;
            this.Switch(1);
        },
        'activePage':function(){
            this.endPage = Math.ceil(this.activePage/this.maxPageItem) * this.maxPageItem;
            this.startPage = this.endPage - this.maxPageItem + 1;
        }
    },
    methods: {
        Switch(index) {
            if ( index > 0 && index <= this.totalPage) {
                this.activePage = index;    

                var start = this.rowPageCount * this.activePage - (this.rowPageCount-1);
                var end = start + this.rowPageCount
                this.$emit('start', start); 
                this.$emit('end', end); 
                window.scrollTo({top: 0,behavior: 'smooth'})
            }    
           

        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/index/shared/Pagination.vue